import React from "react";
import { Map } from "ol";

const MapContext = React.createContext<Map | null>(null);

export default MapContext;
